<template>
    <div>
        <div class="flex justify-between items-center">
            <h4 class="font-heading-sm-semibold">Current Contract Type</h4>
            <DesignButton
                v-if="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
                btnText="Add"
                btnSize="SM"
                btnType="PRIMARY"
                btnVariant="BORDER"
                :btnDisabled="false"
                @click="addButtonClick"
            >
                <template #front-icon>
                    <AddIcon :width="16" :height="16" color="text-primary-3" weight="REGULAR" />
                </template>
            </DesignButton>
            <!-- <button
                v-if="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
                class="flex items-center justify-center border rounded-2 border-primary-3 w-20 h-[2.25rem] bg-white font-body-sm-medium text-primary-3 hover:bg-primary-1 transition-all duration-500 text-center"
                @click="addButtonClick">
                Add
            </button> -->
        </div>

        <template v-for="(valid, index) in contractValidList" :key="index">
            <div class="mt-3 p-4 border border-border-basic-2 rounded-03">
                <div class="flex justify-between">
                    <div class="flex items-center gap-2">
                        <div class="py-[6px] px-2 bg-accent-green-3 rounded-2 font-caption-md-semibold text-white w-fit">
                            Active contract
                        </div>
                        <div class="font-heading-sm-semibold">{{ changedType(valid.employmentType) }}</div>
                    </div>
                        <ElementsDropDown
                            :permissionCheck="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
                            :menuItems="[
                                { label: 'Edit', action: () => clickEditButton(valid), visible: true },
                                { label: 'Delete', action: () => deleteContractModalOpen(valid), visible: true },
                        ]" />
                    </div>
                <div class="font-body-md-regular mt-2 text-content-basic-2">{{ getDatePeriodString(valid) }}</div>
                <div class="font-body-sm-regular mt-1 text-content-basic-3">PIC: {{ valid.picName }}</div>
                <div class="font-body-sm-regular text-content-basic-3">{{ valid.contractInfoContent }}</div>
            </div>
        </template>

        <template v-for="(upcoming, index) in contractUpcomingList" :key="index">
            <div class="mt-3 p-4 border border-border-basic-2 rounded-03">
                <div class="flex justify-between">
                    <div clas="flex items-center gap-2">
                        <div class="py-[6px] px-2 bg-primary-3 rounded-2 font-caption-md-semibold text-white w-fit">
                            Upcoming contract
                        </div>
                        <div class="font-heading-sm-semibold">{{ changedType(upcoming.employmentType) }}</div>
                    </div>
                    <ElementsDropDown
                        :permissionCheck="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
                        :menuItems="[
                            { label: 'Edit', action: () => clickEditButton(upcoming), visible: true },
                            { label: 'Delete', action: () => deleteContractModalOpen(upcoming), visible: true },
                        ]" />
                </div>

                <div class="font-body-md-regular mt-2 text-content-basic-2">{{ getDatePeriodString(upcoming) }}</div>
                <div class="font-body-sm-regular mt-1 text-content-basic-3">PIC: {{ upcoming.picName }}</div>
                <div class="font-body-sm-regular text-content-basic-3">{{ upcoming.contractInfoContent }}</div>
            </div>
        </template>

        <template v-if="contractValidList == null && contractUpcomingList == null">
            <div>&ensp;</div>
        </template>

        <template v-else-if="contractValidList.length == 0 && contractUpcomingList.length == 0">
            <div class="mt-3 p-4 border border-border-basic-2 rounded-03">
                <div :class="[employeeData.employeeStatus == 'RESIGNED' ? 'bg-background-basic-4 text-content-basic-1' : 'bg-accent-red-3 text-white']"
                    class="py-[6px] px-2 rounded-2 font-caption-md-semibold text-white w-fit">
                    No active contract
                </div>
                <div v-if="employeeData.employeeStatus == 'RESIGNED'" class="font-body-md-regular mt-2 text-content-basic-2">
                    &#9888; This employee has resigned.
                </div>
                <div v-else class="font-body-md-regular mt-2 text-content-basic-2">
                    &#9888; Please add this employee’s contract information if still employed.
                </div>
            </div>
        </template>
    </div>

    <div class="mt-8">
        <div class="flex justify-between items-center mb-3">
            <h4 class="font-heading-sm-semibold">Contract History</h4>
        </div>
        <template v-for="(expire, idx) in contractExpiredList" :key="idx">
            <div class="py-3 border-t border-border-basic-2">
                <div class="flex justify-between items-center">
                    <div class="font-body-md-semibold">{{ changedType(expire.employmentType) }}</div>
                    <ElementsDropDown
                        :permissionCheck="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
                        :menuItems="[
                            { label: 'Edit', action: () => clickEditButton(expire), visible: true },
                            { label: 'Delete', action: () => deleteContractModalOpen(expire), visible: true },
                        ]"
                        :dropUp="contractExpiredList.length - 1 === idx" 
                        class="right-1"/>
                </div>
                <div class="font-body-md-regular mt-2 text-content-basic-2">{{ getDatePeriodString(expire) }}</div>
                <div class="font-body-sm-regular text-content-basic-3">PIC: {{ expire.picName }}</div>
                <div class="font-body-sm-regular mt-1 text-content-basic-3">{{ expire.contractInfoContent }}</div>
            </div>

            </template>
        </div>

    <Teleport to="body">
        <ElementsModal2Button
            v-model="showDeleteCheckModal"
            @afterClick="deleteContractHistory"
            :hasAlertIcon="true"
            modalContent=""
            :buttonText="'Confirm'"
            :buttonColor="'RED'"
            :modalTitle="'Are you sure you want to delete this contract information?'" />

        <AppPopup
            v-if="$appUtil.checkPermission('CONTRACT_INFO_EDIT')"
            v-model="showContractInfoModal"
            name="Contract Information"
            buttonText="Save"
            maxWidth="640px"
            @buttonEvent="clickSaveContractModal()">

            <div class="p-6 pt-1">
                <div class="mt-4">
                    <p class="c_label mandatory mb-2">
                        Employment Type
                    </p>
                    <div v-if="popupItems.editMode == 'NEW'" class="flex-1">
                        <DesignDropdownSelect
                            v-model="popupItems.employmentType"
                            placeholder="Select Employment Type"
                            :options="employmentTypeOptions"
                            class="flex-1"
                            :width="'w-full'"
                        />
                        <p v-show="popupError.employmentType" class="c_alert_message mt-1">
                            Employment Type can’t be blank
                        </p>
                    </div>
                    <div v-else-if="popupItems.editMode == 'EDIT'" 
                        class="w-full h-[2.75rem] border border-border-basic-2 rounded-2 bg-background-basic-3 flex items-center px-3 font-body-sm-regular"
                    >
                        {{ changedType(popupItems.employmentType) }}
                    </div>
                </div>

                <div class="mt-4">
                    <p class="c_label mandatory mb-2">
                        Start Date
                    </p>
                    <div class="flex-1">
                        <ElementsDatePicker
                            v-if="showContractInfoModal"
                            v-model="popupItems.employeeContractInfoStartDatetime"
                            placeholder="Select Date"
                            :textLeft="true"
                            :format="dateFormat" />
                        <p v-show="popupError.employeeContractInfoStartDatetim" class="c_alert_message mt-1">
                            Start Date can’t be blank.
                        </p>
                    </div>
                </div>

                <div class="mt-4">
                    <p class="c_label mb-2"
                        :class="{ 'mandatory': requiredEndDate }">
                        End Date
                    </p>
                    <div class="flex-1">
                        <ElementsDatePicker
                            v-if="showContractInfoModal"
                            v-model="popupItems.employeeContractInfoEndDatetime"
                            placeholder="Select Date"
                            :textLeft="true"
                            :format="dateFormat"
                            :wrapperClass="'drop-up-4rem'" />
                        <p v-show="popupError.employeeContractInfoEndDatetime" class="c_alert_message mt-1">
                            {{ popupErrorMsg.employeeContractInfoEndDatetime }}&ensp;
                        </p>
                    </div>
                </div>

                <div class="mt-4">
                    <p class="c_label mandatory mb-2">
                        Notes
                    </p>
                    <div class="flex-1">
                        <DesignInput
                            v-model="popupItems.contractInfoContent"
                            :maxlength="20"
                            :width="'w-full'"
                            @input="checkMaxLength($event, 'contractInfoContent', 20)" />
                        <p v-show="popupError.contractInfoContent" class="c_alert_message mt-1">
                            {{ popupErrorMsg.contractInfoContent }}&ensp;
                        </p>
                    </div>
                </div>

                <div class="mt-4">
                    <p class="c_label mandatory mb-2">
                        PIC
                    </p>
                    <div class="flex-1">
                        <DesignInput
                            v-model="popupItems.picName"
                            :maxlength="15"
                            :width="'w-full'"
                            :disabled="true"/>
                        <p v-show="popupError.picName" class="c_alert_message mt-1">
                            {{ popupErrorMsg.picName }}&ensp;
                        </p>
                    </div>
                </div>
            </div>
        </AppPopup>
    </Teleport>
</template>

<script>
import { contractType } from '@/assets/data/optionData.js';
import { ValidateUtil, CommonDataFormatUtil } from '@/plugins/app-util.js';
import moment from 'moment';
import ElementsModal2Button from '@/components/elements/ElementsModal2Button.vue';
import ElementsDropDown from '@/components/elements/ElementsDropdown.vue';
import ElementsInput from '@/components/elements/ElementsInput.vue'
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignInput from '@/components/design-system/design-input.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import AddIcon from '@/components/design-system/icon/add.vue'

export default {
    components: {
        ElementsModal2Button,
        ElementsDropDown,
        ElementsInput,
        DesignDropdownSelect,
        DesignInput,
        DesignButton,
        AddIcon,
    },
    props: {
        employeeData: Object,
    },
    emits: ['afterSave'],
    data() {
        return {
            dateFormat: 'YYYY-MM-DDTHH:mm:ss.sssZ',
            employeeContractInfoHistorySeq: null,
            employeeSeq: null,
            companySeq: null,
            employmentTypeOptions: contractType,
            // modal
            showDeleteCheckModal: false,
            showContractInfoModal: false,
            employee: {},
            popupItems: {
                editMode: 'NEW',
                employeeSeq: null,
                contractInfoContent: null,
                employmentType: null,
                employeeContractInfoStartDatetime: null,
                employeeContractInfoEndDatetime: null,
                picName: null,
                employeeContractInfoHistorySeq: null,
            },
            popupError: {
                contractInfoContent: false,
                employmentType: false,
                employeeContractInfoStartDatetime: false,
                employeeContractInfoEndDatetime: false,
                dateOrder: false,
                picName: false,
            },
            popupErrorMsg: {
                employeeContractInfoEndDatetime: null,
                picName: null,
                contractInfoContent: null,
            },

            // list - 리스트가 빈 값일 경우 no contract info 가 먼저 노출되는 것을 막기 위해 null 로 초기화 합니다
            contractValidList: null, // 현재
            contractUpcomingList: null, // 미래
            contractExpiredList: [], // 과거
            //_________________________________________________________________________
        }; //return
    }, //data
    methods: {
        changedType: CommonDataFormatUtil.employmentTypeFormat,
        changeDateFormat(date, format = 'MM/DD/YYYY') {
            if (!date) return null;
            const parsed = moment(date).format(format);
            return parsed;
        },
        deleteContractModalOpen(contractInfoHistoryItems) {
            const self = this;
            self.showDeleteCheckModal = true;
            self.employeeContractInfoHistorySeq = contractInfoHistoryItems.employeeContractInfoHistorySeq;
        },
        deleteContractHistory() {
            const self = this;
            const employeeContractInfoHistorySeq = self.employeeContractInfoHistorySeq;
            const url = self.$api('uri', 'delete-employee-contract-info-history').replace('{employeeContractInfoHistorySeq}', employeeContractInfoHistorySeq);
            self.$axios
                .delete(url)
                .then((res) => {
                    self.$emit('afterSave');
                    self.showDeleteCheckModal = false;
                    self.getEmployeeContractInfoData(self.employeeSeq);
                })
                .catch(console.log);
        },
        editContractInfoSave() {
            const self = this;

            const { employeeContractInfoHistorySeq, employeeContractInfoStartDatetime, employeeContractInfoEndDatetime, employmentType, contractInfoContent, picName } = self.popupItems;
            const requestItem = {
                employeeSeq: self.employeeSeq,
                employeeContractInfoHistorySeq,
                contractInfoContent,
                employmentType,
                employeeContractInfoStartDatetime,
                employeeContractInfoEndDatetime,
                picName,
            };

            const url = self.$api('uri', 'put-employee-contract-info-history');
            self.$axios
                .put(`${url}/${encodeURIComponent(employeeContractInfoHistorySeq)}`, requestItem)
                .then((res) => {
                    self.showContractInfoModal = false;
                    self.getEmployeeContractInfoData();
                    self.$emit('afterSave');
                })
                .catch((err) => {
                    console.log(err.response);
                });
        },
        saveContractInfo() {
            const self = this;
            const { employeeContractInfoStartDatetime, employeeContractInfoEndDatetime, employmentType, contractInfoContent, picName } = self.popupItems;
            const requestItem = {
                employeeSeq: self.employeeSeq,
                contractInfoContent,
                employmentType,
                employeeContractInfoStartDatetime,
                employeeContractInfoEndDatetime,
                picName,
            };
            const url = self.$api('uri', 'post-employee-contract-info-history');
            self.$axios
                .post(url, requestItem)
                .then((res) => {
                    self.$emit('afterSave');
                    self.showContractInfoModal = false;
                    self.getEmployeeContractInfoData();
                })
                .catch((err) => {
                    console.log(err.response);
                })
        },
        getEmployeeContractInfoData() {
            const self = this;
            const url = self.$api('uri', 'get-employee-contract-info-history').replace('{employeeSeq}', self.employeeSeq);

            self.$axios
                .get(url)
                .then((res) => {
                    const { validList, expiredList, upcomingList } = res.data.data;
                    self.contractValidList = validList;
                    self.contractExpiredList = expiredList;
                    self.contractUpcomingList = upcomingList;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        duplicateContractCheck(duplicateRequest, afterSuccess) {
            const self = this;

            if (self.validateContractInfo()) {
                return;
            }

            const url = self.$api('uri', 'post-check-contract-info-period-duplication');
            self.$axios
                .post(url, duplicateRequest)
                .then((res) => {
                    const { isOnRegular, isOverlap, isBeforeTargetStartDate } = res.data.data;
                    if (isOnRegular) {
                        alert('Please enter the End Date for the existing contract type to add a new one.');
                        return;
                    }
                    if (isOverlap) {
                        alert('Contract periods cannot overlap with existing contract. Please check again.');
                        return;
                    }

                    if (isBeforeTargetStartDate) {
                        alert('If the start date is earlier than the existing contract record, the end date must be mandatory.');
                        return;
                    }

                    afterSuccess();
                })
                .catch((err) => {
                    console.log('fail: ', err);
                });
        },
        addSubmitRequestAfterConfirm() {
            const self = this;
            const startDate = self.popupItems.employeeContractInfoStartDatetime;
            const endDate = self.popupItems.employeeContractInfoEndDatetime;
            const employeeSeq = self.employeeSeq;
            const requestItem = { startDate, endDate, employeeSeq };
            // duplication check and do save
            self.duplicateContractCheck(requestItem, () => self.saveContractInfo());
        },
        editSubmitRequestAfterConfirm() {
            const self = this;

            const { employeeContractInfoHistorySeq, employeeContractInfoStartDatetime, employeeContractInfoEndDatetime } = self.popupItems;
            const employeeSeq = self.employeeSeq;
            const requestItem = {
                startDate: employeeContractInfoStartDatetime,
                endDate: employeeContractInfoEndDatetime,
                employeeSeq,
                employeeContractInfoHistorySeq,
            };
            // duplication check and do save
            self.duplicateContractCheck(requestItem, () => self.editContractInfoSave());
        },
        validateContractInfo() {
            const self = this;
            self.errorMessageClear();
            const startDate = self.popupItems.employeeContractInfoStartDatetime;
            const endDate = self.popupItems.employeeContractInfoEndDatetime;
            let hasError = false;

            if (self.popupItems.employmentType === null) {
                self.popupError.employmentType = true;
                hasError = true;
            }

            if (ValidateUtil.checkIsEmpty(startDate)) {
                self.popupError.employeeContractInfoStartDatetime = true;
                hasError = true;
            }

            if (self.requiredEndDate) {
                if (ValidateUtil.checkIsEmpty(endDate)) {
                    self.popupError.employeeContractInfoEndDatetime = true;
                    self.popupErrorMsg.employeeContractInfoEndDatetime = 'End Date can’t be blank';
                    hasError = true;
                }
            }

            if (startDate > endDate) {
                self.popupError.employeeContractInfoEndDatetime = true;
                self.popupErrorMsg.employeeContractInfoEndDatetime = 'Start date must be prior to the end date.';
                hasError = true;
            }

            if (ValidateUtil.checkIsEmpty(self.popupItems.contractInfoContent)) {
                self.popupError.contractInfoContent = true;
                self.popupErrorMsg.contractInfoContent = 'Please enter Notes to proceed.';
                hasError = true;
            }

            if (ValidateUtil.checkIsEmpty(self.popupItems.picName)) {
                self.popupError.picName = true;
                self.popupErrorMsg.picName = 'Please enter PIC to proceed.';
                hasError = true;
            }

            return hasError;
        },
        //open Modal
        clickSaveContractModal() {
            const self = this;

            if (self.popupItems.editMode == 'NEW') {
                self.addSubmitRequestAfterConfirm();
                return;
            }
            if (self.popupItems.editMode == 'EDIT') {
                self.editSubmitRequestAfterConfirm();
                return;
            }
        },
        clickEditButton(history) {
            const self = this;
            const { employeeSeq, employmentType, picName, contractInfoContent, employeeContractInfoStartDatetime, employeeContractInfoEndDatetime, employeeContractInfoHistorySeq } = history;
            self.popupItems = {
                editMode: 'EDIT',
                employeeSeq,
                contractInfoContent,
                employmentType,
                picName,
                employeeContractInfoStartDatetime,
                employeeContractInfoEndDatetime,
                employeeContractInfoHistorySeq,
            };
            self.errorMessageClear();
            self.showContractInfoModal = true;
        },
        addButtonClick() {
            const self = this;
            self.popupItems = {
                editMode: 'NEW',
                employeeSeq: null,
                contractInfoContent: null,
                employmentType: null,
                employeeContractInfoStartDatetime: null,
                employeeContractInfoEndDatetime: null,
                picName: sessionStorage.getItem("pic"),
                employeeContractInfoHistorySeq: null,
            };
            self.errorMessageClear();
            self.showContractInfoModal = true;
        },
        errorMessageClear() {
            const self = this;
            Object.keys(self.popupError).forEach((key) => {
                self.popupError[key] = false;
            });
            Object.keys(self.popupErrorMsg).forEach((key) => {
                self.popupErrorMsg[key] = null;
            });
        },
        getDatePeriodString({ employeeContractInfoStartDatetime, employeeContractInfoEndDatetime }) {
            const self = this;
            const start = self.changeDateFormat(employeeContractInfoStartDatetime);
            const end = self.changeDateFormat(employeeContractInfoEndDatetime);
            return [start, end].join(' ~ ');
        },
        checkMaxLength(e, key, max) {
            const value = e.target.value;
            if (value?.length < max) {
                this.popupError[key] = false;
                this.popupErrorMsg[key] = null;
                return;
            }
            this.popupError[key] = true;
            this.popupErrorMsg[key] = `Please limit to ${max} characters.`;
        },
        //_________________________________________________________________________________________________________________________________________
    },
    mounted() {
        const self = this;
        self.employeeSeq = self.employeeData.employeeSeq;
        self.companySeq = self.employeeData.companySeq;

        self.getEmployeeContractInfoData();
    },
    computed: {
        requiredEndDate() {
            const self = this;
            let isRequired = false;
            let employmentType = self.popupItems.employmentType;
            switch (employmentType) {
                case 'FULL_TIME':
                    isRequired = false;
                    break;
                case 'DAILY_WAGE':
                    isRequired = false;
                    break;
                case 'PROBATION':
                    isRequired = true;
                    break;
                case 'FIXED_TERM_CONTRACT':
                    isRequired = true;
                    break;
                case 'PROJECT_BASE':
                    isRequired = true;
                    break;
                case 'OUTSOURCE':
                    isRequired = true;
                    break;
                case 'TEMPORARY':
                    isRequired = true;
                    break;
                case 'PART_TIME':
                    isRequired = true;
                    break;
                case 'CONSULTANT':
                    isRequired = true;
                    break;
                case 'HOURLY_WAGE':
                    isRequired = true;
                    break;
            }

            return isRequired;
        },
    },
};
</script>
